<template>
    <form @submit.prevent="$emit('submitted')" :class="layoutClasses">
        <slot />
    </form>
</template>

<script>

export default {
    emits: ['submitted'],
    props: {
        layout: {
            type: String,
            default: 'vertical',//horizontal
        },
        cols: {
            type: String,
            default: '2',
        }
    },
    data() {
        return {
            horizontal: 'horizontal flex items-end',
            vertical: 'vertical flex flex-col',
            horizontal_vertical: 'horizontal flex items-start',//horizontal with items vertical
            columns: 'grid gap-5 grid-cols-' + this.cols,
        }
    },
    computed: {
        layoutClasses() {
            if (this.layout == 'columns') {
                return this.columns;
            } else if (this.layout == 'vertical') {
                return this.vertical;
            } else if (this.layout == 'horizontal_vertical') {
                return this.horizontal_vertical;
            } else {
                return this.horizontal;
            }
        }
    }
}
</script>

<style>
form.horizontal *:not(:last-child) {
    padding-right: 1.25rem;
}
</style>
